import React, { Component } from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import image from "../../../../assets/img/svg/Image.svg"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { DragIndicator } from "@material-ui/icons"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { addprojectprocessinfo, getprojectprocessinfo, getprojectbasicinfo } from "../../../../actions/AddNewProjectAction"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg"

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    background: "#FFFFFF",
    padding: "10px 0",
    ...draggableStyle
});

const getItemStyle1 = (isDragging, draggableStyle) => ({
    userSelect: "none",
    background: "#FFFFFF",
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: "#FFFFFF",
});

class AddPRO extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            count: "0",
            Loop: [],
            cancel: false,
            ProjectName: "New Project",
            addData: {
                ProjectId: 0,
                ProjectProcessOrder: [],
                Modify: ''
            },
        }
    }

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    componentDidMount() {
        this.state.ProjectName = localStorage.getItem("ProjectName");
        this.state.addData.Modify = localStorage.getItem("UserRoles");
        this.setState({})
        if (window.location.pathname == '/process/add') {
            if (localStorage.getItem("addeditid") != null) {
                this.getprojectprocessinfo(localStorage.getItem("addeditid"))
            }
        }
        if (window.location.pathname == '/process/edit') {
            this.getprojectprocessinfo(localStorage.getItem("DashId"))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getprojectprocessinfo = (data) => {
        let apiUrl = API.ADDPROCESSINFO_PROJECT + '/' + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "GET",
            url: apiUrl,
            // data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.ProjectId = response?.data?.ProjectId;
                    if (response?.data?.ProjectProcessOrder.length != 0) {
                        this.state.addData.ProjectProcessOrder = response?.data?.ProjectProcessOrder;
                        this.setState({})
                    }
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                } else {
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#P .MuiListItemText-primary").removeClass("fw-bolder")
        $("#PL").removeClass("active-color")
    }

    handleInputChange = (e, id) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.state.addData.ProjectProcessOrder.map((item, index) => {
            if (id == index + 1) {
                item.ProcessText = e.target.value;
            }
        })
        this.setState({});  
    };

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.state.addData.ProjectProcessOrder,
            result.source.index,
            result.destination.index
        );
        this.state.addData.ProjectProcessOrder = items;
        this.setState({});
    }

    AddNew = () => {
        // this.state.Loop.push(parseInt(this.state.count + 1));
        // this.state.count = parseInt(this.state.count + 1);
        // this.setState({})
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({})
        this.state.addData.ProjectProcessOrder.push(
            {
                ProcessText: "",
                SNo: parseInt(this.state.count + 1),
                OderNumber: 0
            }
        )
        this.state.count = parseInt(this.state.count + 1)
        this.setState({})
    };

    // sidebar = () => {
    //     if (window.location.pathname == '/process/edit') {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (window.location.pathname == '/process/edit') {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (window.location.pathname == '/process/edit') {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Pro1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Process1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Process").removeClass("d-none");
        $("#Process").addClass("d-block");
        $("#P .MuiListItemText-primary").addClass("fw-bolder");
        $("#PL").addClass("active-color");
    };

    Save = () => {
        const { ProjectId, ProjectProcessOrder } = this.state.addData
        if ((ProjectId !== 0 || ProjectId !== undefined) && ProjectProcessOrder.length !== 0) {
            this.props.dispatch({ type: "CANCEL", data: false });
            let tempData = [];
            this.state.addData.ProjectProcessOrder.map((item, index) => {
                if (item.ProcessText != "") {
                    tempData.push(item)
                }
            })
            this.state.addData.ProjectProcessOrder = tempData;
            this.setState({})
            this.state.addData.ProjectProcessOrder.map((item, index) => {
                item.OderNumber = parseInt(index + 1);
                this.setState({})
            })
            this.setState({ cancel: false })
            this.props.dispatch(addprojectprocessinfo(this.state.addData))
        } else {
            this.props.navigate(`/process/add`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    render() {
        // const { ProcessText, SNo, OderNumber } = this.state.addData.ProjectProcessOrder
        const { isError1, isError2, isError3, Loop, isEdit } = this.state;
        let { classes, getprocessinfo, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Pro" + "1"} className='textNaviIcon' primary={window.location.pathname == '/process/edit' ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="Pro" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Process</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <span className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                        </td>
                                        <td className="border-right text-center">
                                            <span className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                        </td>
                                        <td className="">
                                            <span className={classes.button} onClick={() => this.AddNew()} ><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable form-group" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td width="5%" className="text-center">
                                                <button className={`${classes.button}`} onClick={() => this.Save()} style={{ minWidth: '60px'}}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                            </td><td width="5%" className="border-right text-left">
                                                <button className={`${classes.button}`} onClick={this.AddCancel1} style={{ minWidth: '70px', marginLeft: '-20px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>

                                            </td>
                                            <td width="85%" className="text-left"><button className={classes.button} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                              

                            </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                      
                        <div className="row w-100 ml-3 pr-1 pl-1 pb-2" >
                            <div className="col-3 col-sm-2 col-xs-4 col-md-2 col-lg-2 col-xl-1 mt-3 border-right px-1" >
                                <label className="spandoc-thead" style={{ color: "#000000" }}>Steps</label>
                            </div>

                            <div className="col-9 col-sm-10 col-xs-8 col-lg-10 col-xl-11 col-md-10 mt-3 px-2">
                                <span className="spandoc-thead" style={{ color: "#000000" }}>Activities</span>
                            </div>
                        </div>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {this.state.addData.ProjectProcessOrder && this.state.addData.ProjectProcessOrder.map((item, index) => {
                                            return (
                                                <Draggable draggableId={"Step" + index} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                          
                                                            <div className="row w-100 ml-2 pr-1 pl-1" >
                                                                <div className={this.state.isMobile ? "col-3 col-sm-2 col-xs-4 col-md-2 col-lg-2 col-xl-1 px-0" : "col-3 col-sm-2 col-xs-4 col-md-2 col-lg-2 col-xl-1 pr-4"}>
                                                                    <label className="border-bottom border-left border-top fw-500 f-size-13 pt-2" style={{ height: "55px", minWidth: '150px' }}><DragIndicator className={`${classes.dragIcon} `} />
                                                                        Step {index + 1}
                                                                    </label>
                                                                </div>
                                                                <div className={this.state.isMobile ? "col-9 col-sm-10 col-xs-8 col-lg-10 col-xl-11 col-md-10 pr-3" : "col-9 col-sm-10 col-xs-8 col-lg-10 col-xl-11 col-md-10 pr-4"}>
                                                                    <input type="text" style={{ height: "55px", minWidth: '100%', marginLeft: '-5px' }} id={"Step" + index + 1} value={item.ProcessText} onChange={(e) => this.handleInputChange(e, index + 1)} className="form-control border-radius pr-2 fw-500 f-size-13" />
                                                                  
                                                                </div>
                                                            </div>
                                                           
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        // projectStatus: state.projectReducer.projectStatus || [],
        getprojectid: state.AddNewProjectReducer.getprojectid || [],
        getprocessinfo: state.AddNewProjectReducer.getprocessinfo || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

AddPRO.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddPRO))
);